export interface Country {
  id: number | string;
  code: string;
  name: string;
  languageId: number;
}

export interface CountryResponse {
  error: any[];
  success: boolean;
  value: CountryV2[];
}


export interface CountryV2 {
  id: string;
  code:string;
  name: string;
}

export interface StateResponse {
  error: any[];
  success: boolean;
  value: StateV2[];
}


export interface StateV2 {
  id: string;
  value: string;
}

export interface DepartmentResponse {
  error: any[];
  success: boolean;
  value: DepartmentV2[];
}

export interface DepartmentV2 {
  id: string;
  value: string;
}

export interface DistrictResponse {
  error: any[];
  success: boolean;
  value: DistrictV2[];
}

export interface DistrictV2 {
  id: string;
  value: string;
}


export interface State {
  id: string;
  code: string;
  nameEnglish: string;
  nameSpanish: string;
  countryId: string;
  createdDate: string;
  createdUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  lastModifiedUserEmail: string;
  migId: string;
}

export interface Department {
  id: string;
  code: string;
  nameEnglish: string;
  nameSpanish: string;
  countryId: string;
  stateId: string;
  createdDate: string;
  createdUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  lastModifiedUserEmail: string;
  migId: string;
}

export interface District {
  id: string;
  code: string;
  nameEnglish: string;
  nameSpanish: string;
  countryId: string;
  stateId: string;
  departmentId: string;
  createdDate: string;
  createdUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  lastModifiedUserEmail: string;
  migId: string;
}

export interface CountryTimeZone {
  id: string;
  name: string;
  code: string;
  languageId: string;
  imgFlag: string;
  value: string;
  isoCurrency: string;
  isoCode: string;
}

export interface CountryWithCode {
  id: string;
  code: string;
  createdDate: Date;
  createdUser: Date;
  isoCode: string;
  isoCurrency: string;
  language: string;
  languageId: string;
  lastModifiedDate: Date;
  lastModifiedUser: string;
  lastModifiedUserEmail: string;
  migId: string;
  name: string;
  organizations: any[]
}

export interface IUserCountry {
  CountryName: string,
  IsoCurrencyCode: string,
  IsoCountryCode: string
}
